import {React} from 'react';
import FormComponent from './FormComponent';
import ModalDialog from './ModalDialog';
import i18next from 'i18next';
import * as blockUtils from '../../utils/BlockUtils';
import PropTypes from 'prop-types';

class JsonDialog extends FormComponent {
  constructor(props) {
    super(props);
  }

  initialState() {
    return {
      jsonData: JSON.stringify(JSON.parse(this.props.jsonData), null, 2),
    };
  }

  render() {
    return (
      <ModalDialog
        modalTitle={i18next.t('management_tracking.json_dialog')}
        dialogId={this.props.dialogId}
        onDialogHide={blockUtils.unblockUI}
        onDialogShown={this.onFormShow}
        showCopyToClipboardButton={true}
        dataToCopy={this.props.jsonData}
        showSave={false}
      >
        <div>
          <pre>{this.props.jsonData}</pre>
        </div>
      </ModalDialog>
    );
  }
}

JsonDialog.propTypes = {
  dialogId: PropTypes.string,
  jsonData: PropTypes.string,
};

export default JsonDialog;
